<template>
  <div
    id="change-xzqh"
    class="change-xzqh"
    :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }"
  >
    <!-- <div class="change-xzqh-cascader">
      <el-cascader
        v-model="regionValue"
        :options="xzqhList"
        :props="{ checkStrictly: true }"
        clearable
        @change="changeRegion"
        style="width: 100%"
      ></el-cascader>
    </div> -->
    <!-- <div class="change-xzqh-type">
      <div
        class="change-xzqh-type-span"
        :class="type == '0' ? 'act_color' : ''"
        @click="changeType('0')"
      >
        全部
      </div>
      /
      <div
        class="change-xzqh-type-span"
        :class="type == '1' ? 'act_color' : ''"
        @click="changeType('1')"
      >
        推荐地块
      </div>
      /
      <div
        class="change-xzqh-type-span"
        :class="type == '2' ? 'act_color' : ''"
        @click="changeType('2')"
      >
        新增地块
      </div>
    </div> -->
  </div>
</template>
<script>
import { getXzqhList } from "@/api/common";
export default {
  name: "",
  props: {
    // defaultCounty: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },
  },
  data() {
    return {
      screenIndexWidth: null,
      //regionValue: ["53"],
      xzqhList: [],
      type: "0",
    };
  },
  watch: {
    // defaultCounty: function (val) {
    //   if (val.length) {
    //     this.regionValue = this.defaultCounty;
    //   }
    // },
  },
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
    //this.getXzqh();
  },
  methods: {
    //获取行政区划
    getXzqh() {
      getXzqhList().then((res) => {
        if (res.data.success) {
          this.xzqhList = res.data.data;
        }
      });
    },

    //选择行政区划
    changeRegion(arr) {
      this.$emit("callBackRegion", arr);
    },

    //type:0.全部 1.推荐  2.新增
    changeType(val) {
      this.type = val;
      this.$emit("changeType", val);
    },
  },
};
</script>

<style scoped>
.change-xzqh {
  display: flex;
  width: 100%;
  height: 28px;
  line-height: 28px;
}

.change-xzqh-cascader {
  width: 200px;
}
.change-xzqh-type {
  display: flex;
  font-weight: 600;
}
.change-xzqh-type-span {
  font-size: 0.95rem;
  padding: 0 5px;
  cursor: pointer;
}
.act_color {
  color: #409eff;
}
</style>